
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import './RedRoundBtn.css'

const RedRoundBtn = (props) => {

  
    
    return (
        <button className={`RedRoundBtn ${props.selected ? "selected" : ""}`} onClick={props?.onClick} type={props.type || 'button'}>
            {props?.lefticon && (
                <div className='icon_holder'>
                    <FontAwesomeIcon icon={props?.lefticon} className='lefticon' />
                </div>
            )}
            <p className='btn_text'>{props?.btn_name}</p>
            {props?.icon && (
                <FontAwesomeIcon icon={props?.icon} className='icon' />
            )}
        </button>
    )
}

export default RedRoundBtn
